/**
 * Fork overlay (new file, no OSS equivalent) — EVA-M7 (7.1).
 * Bind/unbind an Eva assistant to the account's inboxes, nested under an assistant
 * (/api/v1/accounts/:account_id/eva/assistants/:assistant_id/inboxes). `list` returns every account
 * inbox annotated with its binding state (bound_to_this / bound_to_other_eva / bound_to_captain).
 */
/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

class EvaInboxesAPI extends ApiClient {
  constructor() {
    super('eva/assistants', { accountScoped: true });
  }

  list(assistantId) {
    return axios.get(`${this.url}/${assistantId}/inboxes`);
  }

  bind(assistantId, inboxId) {
    return axios.post(`${this.url}/${assistantId}/inboxes`, {
      inbox_id: inboxId,
    });
  }

  unbind(assistantId, inboxId) {
    return axios.delete(`${this.url}/${assistantId}/inboxes/${inboxId}`);
  }
}

export default new EvaInboxesAPI();
